import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

export function makeSetStateHandler<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
    form: UseFormReturn<TFieldValues>,
    fieldName: TName
) {
    return (value: React.SetStateAction<TFieldValues[TName]>) => {
        const resolved = typeof value === 'function'
            ? (value as (prev: TFieldValues[TName]) => TFieldValues[TName])(form.getValues(fieldName))
            : value;

        form.setValue(fieldName, resolved, {
            shouldValidate: true,
            shouldDirty: true,
        });
    };
}
